























































































































































































































































import {
  Component,
  Prop,
  Provide,
  ProvideReactive,
  Vue,
  Watch,
} from "vue-property-decorator";
import { confirmDeletion, GlobalHelper } from "@/helper/global-helper";
import { ErrorBag, Validator } from "vee-validate";
import { PageStore, PageStores } from "@/store/modules/page-store";
import Spinner from "@/components/Spinner.vue";
import TOMFragebogen from "../TOMFragebogen";
import TOMFragebogenUeberschrift1Ordnung from "../components/TOMFragebogen-Ueberschrift-1Ordnung.vue";
import TOMFragebogenUeberschrift2Ordnung from "../components/TOMFragebogen-Ueberschrift-2Ordnung.vue";
import TOMFragebogenMassnahme from "../components/TOMFragebogen-Massnahme.vue";
import TOMFragebogenKapitel from "../components/TOMFragebogen-Kapitel.vue";
import TOMFragebogenBausteinGruppe from "../components/TOMFragebogen-Baustein-Gruppe.vue";
import TOMFragebogenDummy from "../TOMFragebogen-Dummy";
import TOMFragebogenDropPlatzhalter from "../components/TOMFragebogen-Drop-Platzhalter.vue";
import refreshFragebogen from "../logic/refreshFragebogen";
import { UserModule, UserStore } from "@/store/modules/currentuser-store";
import TOMFragebogenViewContainer from "../components/TOMFragebogen-View-Container.vue";

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);

@Component({
  components: {
    Spinner,
    TOMFragebogenUeberschrift1Ordnung,
    TOMFragebogenUeberschrift2Ordnung,
    TOMFragebogenMassnahme,
    TOMFragebogenKapitel,
    TOMFragebogenBausteinGruppe,
    TOMFragebogenDropPlatzhalter,
  },
})
export default class TOMFragebogenEditor extends TOMFragebogenViewContainer {
  public isLoading: boolean = true;
  public modus: TOMFragebogen.Modus = TOMFragebogen.Modus.BearbeitenEbene1;

  @Watch("$route", { deep: true })
  public updateModus() {
    const TOMFragebogenModus =
      this.$route.query[TOMFragebogen.Constants.ModusQueryKey];
    if (TOMFragebogenModus) {
      this.modus = +TOMFragebogenModus;
    } else {
      this.setQueryModusTo(TOMFragebogen.Modus.BearbeitenEbene1);
    }
  }

  public onKlappen(baustein: TOMFragebogen.Baustein) {
    const index = this.fragebogen.TomBausteine.findIndex(
      (c) => c.Id === baustein.Id
    );
    if (index !== -1) {
      const istAufgeklappt =
        this.fragebogen.TomBausteine[index][
          TOMFragebogen.Baustein.Symbols.istAufgeklappt
        ];
      this.fragebogen.TomBausteine[index][
        TOMFragebogen.Baustein.Symbols.istAufgeklappt
      ] = istAufgeklappt !== undefined ? !istAufgeklappt : true;
      refreshFragebogen(this.fragebogen);
    }
  }

  public async loadHauptfragebogen() {
    try {
      this.isLoading = true;
      const response = await this.api.GetHauptFragebogen();
      const clone = (window as any).structuredClone(response);
      const filled = TOMFragebogen.Logic.fillSymbolsFragebogen(clone);
      this.fragebogen = filled;
      this.isLoading = false;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  public handleRouteLeave(to: any, from: any, next: any) {
    const allRefs = this.fragebogen.TomBausteine.map((c) => this.$refs[c.Id])
      .flat()
      .filter((c) => c);

    const someRefDirty = allRefs.some(
      (c) => (c as any).isDirty || (c as any).wirdEditiert
    );

    const isDirty =
      someRefDirty ||
      (this.fragebogen.TomBausteine
        ? this.fragebogen.TomBausteine.some(
            (c) => c[TOMFragebogen.Baustein.Symbols.istNeu] || false
          )
        : false);

    if (isDirty) {
      confirmDeletion(
        this.$t("Nicht gespeicherte Änderungen"),
        this.$t(
          "Sie haben nicht gespeicherte Änderungen auf dieser Seite - Möchten Sie die Seite verlassen und die Änderungen verwerfen?"
        ),
        this.$t("Ohne speichern verlassen"),
        this.$t("Abbrechen"),
        async () => {
          next(true);
        },
        () => {
          next(false);
        }
      );
    } else {
      next();
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    this.handleRouteLeave(to, from, next);
  }

  public async onMount() {
    await this.loadHauptfragebogen();
    let queryModus: string | number | null =
      this.$route.query[TOMFragebogen.Constants.ModusQueryKey];
    queryModus = queryModus !== undefined ? +queryModus : null;
    if (queryModus !== null) {
      this.modus = queryModus;
    }
  }
}
